module.exports = __webpack_public_path__ + "img/ecommerce.29e3478a.png";